var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "container" },
    [
      _c(
        "b-tabs",
        {
          model: {
            value: _vm.tabIndex,
            callback: function($$v) {
              _vm.tabIndex = $$v
            },
            expression: "tabIndex"
          }
        },
        [
          _c(
            "b-tab",
            { attrs: { title: "User Login" } },
            [_c("login-form", { on: { userLogin: _vm.toggleModal } })],
            1
          ),
          _c(
            "b-tab",
            { attrs: { title: "Registration" } },
            [_c("register-form", { on: { userRegister: _vm.register } })],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "pdpa-consent",
          attrs: {
            id: "pdpa-consent-modal",
            size: "lg",
            title: "PDPA Consent - Please Read Carefully)"
          }
        },
        [
          _c("p", [
            _vm._v(
              " ************* PDPA CONSENT (please read carefully) **************** "
            )
          ]),
          _c("p", [
            _vm._v(
              "\n        The information collected through this website is for verification purposes to confirm all personnel registered are authorized to work in the projects specified.\n      "
            )
          ]),
          _c("p", [
            _vm._v(
              "\n        I hereby give consent to Exyte Singapore Pte Ltd and all related parties to collect and store the personal information of my company personnel including, but not limited to, Personal Identification Numbers (NRIC/FIN/Passport, etc.,) , Full Name, Designation and Company Name for this purpose.\n      "
            )
          ]),
          _c("p", [_vm._v(" ***************************** ")]),
          _c(
            "div",
            {
              staticClass: "w-100",
              attrs: { slot: "modal-footer" },
              slot: "modal-footer"
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "w-100",
                  attrs: { variant: "success", size: "sm" },
                  on: { click: _vm.userLogin }
                },
                [_vm._v("\n          Accept Consent to Login\n        ")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a183b29", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a183b29","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2a183b29","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/index.vue
// module chunks = 7